import request from '../utils/request';
// 初始参数 /app/config
export function getconfig(data) {
	return request({
		url: '/app/config',
		method: 'post',
		data,
	});
}

// 读取玩家游戏（不分页）
export function getGameAll(data) {
	return request({
		url: '/user/get_game_all',
		method: 'post',
		dataType: 'json',
		data: data,
	});
}
// 海外商品列表
export function webItemList(data) {
	return request({
		url: '/user/web_item_list',
		method: 'post',
		dataType: 'json',
		data: data,
	});
}

// 优惠券列表
export function myCoupon(data) {
	return request({
		url: '/coupon/my',
		method: 'post',
		dataType: 'json',
		data: data,
	});
}
// 查询冻结中的优惠券
export function queryCouponOrder(data) {
	return request({
		url: '/pay/query_coupon_order',
		method: 'post',
		dataType: 'json',
		data: data,
	});
}
// 优惠券兑换
export function exchangeCode(data) {
	return request({
		url: '/coupon/exchange_code',
		method: 'post',
		dataType: 'json',
		data: data,
	});
}
// 我的订单
export function myTrade(data) {
	return request({
		url: '/trade/my',
		method: 'post',
		dataType: 'json',
		data: data,
	});
}
// 验证access token
export function verifyToken(data) {
	return request({
		url: '/user/verify_token',
		method: 'post',
		dataType: 'json',
		data: data,
	});
}
// 关闭订单
export function payClose(data) {
	return request({
		url: '/pay/close',
		method: 'post',
		dataType: 'json',
		data: data,
	});
}
// 支付状态查询
export function payQuery(data) {
	return request({
		url: '/pay/query',
		method: 'post',
		dataType: 'json',
		data: data,
	});
}
// /user/uid_login
export function uid_login(data) {
	return request({
		url: '/user/uid_login',
		method: 'post',
		data,
	});
}
// /user/token_renew
export function token_renew(data) {
	return request({
		url: '/user/token_renew',
		method: 'post',
		data,
	});
}
// pay/query_anonymous
export function query_anonymous(data) {
	return request({
		url: '/pay/query_anonymous',
		method: 'post',
		dataType: 'json',
		data: data,
	});
}
